<app-page-header icon="description" title="Órdenes de Consulta" subtitle="Tipos de orden de consulta del sistema"></app-page-header>

<!-- Ventana de contenido -->
<div class="andorra-apply-content ptb-70 animate__animated animate__fadeIn">
    <div class="container">
        <div class="row mx-auto">
            <div class="col-lg-12 col-md-12">
                <div class="apply-form">
                    <!-- Header de acciones -->
                    <div class="af-header">
                        <div class="left">
                            <h3 class="m-0">Administrar tipos</h3>
                            <p class="muted m-0">
                                Creá, editá y gestioná los tipos de orden de
                                consulta.
                            </p>
                        </div>
                        <div class="right">
                            <button
                                mat-stroked-button
                                class="btn-secondary"
                                routerLink="/ordenes-consulta/periodo"
                                style="margin-right: 8px"
                            >
                                Listar órdenes por período
                            </button>

                            <button
                                *ngIf="rows?.length === 0 && !loading"
                                mat-raised-button
                                class="btn-primary"
                                (click)="nuevo()"
                            >
                                + Nuevo
                            </button>

                            <a
                                class="btn btn-warning"
                                routerLink="/configurar-administracion"
                                >Volver</a
                            >
                        </div>
                    </div>

                    <!-- Barra de progreso / errores -->
                    <mat-progress-bar
                        *ngIf="loading"
                        mode="indeterminate"
                    ></mat-progress-bar>
                    <div *ngIf="error" class="error-box">{{ error }}</div>

                    <!-- Tabla -->
                    <div class="table-responsive" *ngIf="!loading && !error">
                        <table
                            mat-table
                            [dataSource]="rows"
                            class="mat-elevation-z1 w-100"
                        >
                            <!-- Nombre -->
                            <ng-container matColumnDef="nombre">
                                <th mat-header-cell *matHeaderCellDef>
                                    Nombre
                                </th>
                                <td mat-cell *matCellDef="let r">
                                    {{ r.nombre }}
                                </td>
                            </ng-container>

                            <!-- Descripción -->
                            <ng-container matColumnDef="descripcion">
                                <th mat-header-cell *matHeaderCellDef>
                                    Descripción
                                </th>
                                <td mat-cell *matCellDef="let r" class="muted">
                                    {{ r.descripcion || "—" }}
                                </td>
                            </ng-container>

                            <!-- Sedes -->
                            <ng-container matColumnDef="sedes">
                                <th mat-header-cell *matHeaderCellDef>Sedes</th>
                                <td mat-cell *matCellDef="let r">
                                    <div class="chips">
                                        <span
                                            class="chip"
                                            *ngFor="
                                                let nombre of r.sedesNombres
                                            "
                                            >{{ nombre }}</span
                                        >
                                        <span *ngIf="!r.sedesNombres?.length"
                                            >—</span
                                        >
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Ventanas -->
                            <ng-container matColumnDef="ventanas">
                                <th mat-header-cell *matHeaderCellDef>
                                    Ventanas
                                </th>
                                <td mat-cell *matCellDef="let r">
                                    {{ formatVentanas(r.ventanas) }}
                                </td>
                            </ng-container>

                            <!-- Activo -->
                            <ng-container matColumnDef="activo">
                                <th mat-header-cell *matHeaderCellDef>
                                    Activo
                                </th>
                                <td mat-cell *matCellDef="let r">
                                    <mat-icon [ngClass]="{ on: r.activo }">{{
                                        r.activo
                                            ? "check_circle"
                                            : "highlight_off"
                                    }}</mat-icon>
                                </td>
                            </ng-container>

                            <!-- Acciones -->
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef>
                                    &nbsp;
                                </th>
                                <!-- header con ancho/altura -->
                                <td mat-cell *matCellDef="let r">
                                    <button
                                        mat-stroked-button
                                        class="btn-secondary"
                                        (click)="editar(r)"
                                    >
                                        Editar
                                    </button>
                                </td>
                            </ng-container>

                            <tr
                                mat-header-row
                                *matHeaderRowDef="displayedColumns"
                            ></tr>
                            <tr
                                mat-row
                                *matRowDef="let row; columns: displayedColumns"
                            ></tr>
                        </table>

                        <div *ngIf="rows.length === 0" class="empty">
                            No hay tipos configurados todavía. Creá el primero
                            con <strong>+ Nuevo</strong>.
                        </div>
                    </div>
                </div>
                <!-- /apply-form -->
            </div>
        </div>
    </div>
</div>
